export const getRandomId = () => `id-${Math.random().toString(36).substring(2, 9)}`;
//# sourceMappingURL=getRandomId.js.map